const { h, render, Component } = require('preact');

class UserName extends Component {
  constructor(props) {
    super(props);
    this.changeUserNameState = this.changeUserNameState.bind(this)
  }

  changeUserNameState() {
    this.props.updateState(this.props.attrs.type, this.props.attrs.counter, this.populateInput(), this.isInputValid())
  }

  getInputHtmlElement() {
    return document.getElementById('user_name_input')
  }

  isInputGiven() {
    return this.getInputHtmlElement().value.trim().length > 0
  }

  readInput() {
    return this.getInputHtmlElement().value.trim()
  }

  isInputValid() {
    if (this.props.attrs.required) {
      return this.isInputGiven()
    }
    return true
  }

  componentDidMount() {
    var username = this.getInputHtmlElement()
    username.addEventListener("keyup", this.changeUserNameState())
  }

  populateInput() {
    var data = {}
    if (this.isInputGiven())
      data.user_name = this.readInput()
    return data
  }

  render() {
    let attrs = this.props.attrs
    let maxLength = 250
    let additional_attributes = attrs.additional_attributes
    if (additional_attributes) {
      let max_characters = additional_attributes.maximum_number_of_characters_or_digits
      if (max_characters) {
        if (max_characters.length > 0) {
          maxLength = parseInt(max_characters)
        }
      }
    }

    return (
      <div>
        <label><strong>{attrs.label}</strong>
          <span class="mandatory-field"> * </span></label>
        <input class="inputField user_name_input" size="40" maxLength={maxLength} type="text"
               name="contactUserName"
               data-bhw={'user_name_input' + attrs.counter} aria-label={attrs.label} id="user_name_input"/>
      </div>
    )
  }
}

module.exports = UserName
